import devSettings from './devSettings.js'

const base = document.querySelector('base'),
      url = (base && base.href) ? base.href.toLowerCase() : window.location.href.toLowerCase(),
      isURL = location => url.includes(location)

const api = {
    isProd: isURL('//seattle.gov') || isURL('www.seattle.gov') || isURL('cenwinw102') || isURL('cenwinw103') || isURL('cenwinw104') || isURL('cenwinw301') || isURL('cenwinw302') || isURL('cenwinw303')  || isURL('awswinw102.ci.seattle.wa.us') || isURL('itdwseadotgv100.ci.seattle.wa.us') || isURL('itdwawsweb200.seattle.dmz') || isURL('itdwigxcms501/seattle') && !isURL('dsspreview'),
    isQA: isURL('wwwqa.seattle.gov') || isURL('itdwigxcms501/qaseattle'),
    isAlphaQA: isURL('alphaqa.seattle.gov'),
    isAtomic: isURL('atomicdesign.seattle.gov'),
    is520: isURL('/seattle_dss'),
    is520QA: isURL('/qaseattle_dss'),
    isLocal: isURL(':808'),
    isLocalDSS: isURL(devSettings.dss),
    is501DssPreview: isURL('seattlev10/dsspreview'),
    isDssPreview: isURL('dsspreview'),
    isTestDss: isURL('itdwigxcms501/test'),
}

const getAPIpath = () => {
    return api.isProd || api.isQA || api.isAlphaQA || api.is520 || api.is520QA || api.isAtomic || api.isTestDss ? url + 'api'
         : api.isLocal ? devSettings.dssapi
         //: api.isLocalDSS ? base.href + 'api'
         : api.isLocalDSS ? 'localhost/jay105/api'
         : api.is501DssPreview ? url.split('seattlev10/dsspreview')[0] + 'seattle/api'
         : api.isDssPreview ? url.split('dsspreview')[0] + '/api'
         : 'noAPI'
}

// console.log(getAPIpath())

export default {
    path: getAPIpath(url),
    ...api,
}